var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{staticClass:"mb-2",attrs:{"data":_vm.data.disk_backups,"columns":_vm.columns,"resizable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }